import React from "react";
import PropTypes from "prop-types";
import { SlideInMenuSubMenuItem } from "./SlideInMenuSubMenuItem";
import * as styles from "./SlideInMenuSubMenu.module.scss";

const SlideInMenuSubMenu = ({ menuLinks, menuOpenState, unmountTrap }) => (
	<ul className={styles.subMenuContainer}>
		{menuLinks.map(menuLink => (
			<SlideInMenuSubMenuItem
				key={menuLink.id}
				menuLink={menuLink}
				menuOpenState={menuOpenState}
				unmountTrap={unmountTrap}
			/>
		))}
	</ul>
);

SlideInMenuSubMenu.propTypes = {
	menuLinks: PropTypes.arrayOf(PropTypes.object).isRequired,
	menuOpenState: PropTypes.bool,
	unmountTrap: PropTypes.func.isRequired,
};

SlideInMenuSubMenu.defaultProps = {
	menuOpenState: false,
};

export default SlideInMenuSubMenu;
export { SlideInMenuSubMenu };
